export const FETCH_VEHICLE_BRAND_HOMEPAGE = 'Home/FETCH_VEHICLE_BRAND_HOMEPAGE';
export const FETCH_VEHICLE_MODEL_HOMEPAGE = 'Home/FETCH_VEHICLE_MODEL_HOMEPAGE';
export const FETCH_HOMEPAGE_DATA = 'Home/FETCH_HOMEPAGE_DATA';
export const REMOVE_FROM_MODEL_LIST = 'Home/REMOVE_FROM_MODEL_LIST';
export const RESET_HOMEPAGE = 'Home/RESET_HOMEPAGE';